module.exports = __webpack_public_path__ + "static/media/Dubai.8febdb34.png";